import {Layout, Tab, TabView, Text} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {Image, StyleSheet} from 'react-native';
import {getTeacherSchedules} from '../../../../apis';
import {getImage} from '../../../../helpers/general';
import {px, safeText, useAsyncFn, useIsLandscape} from '../../../../utils';
import {AppLoadingIndicator, Page, TimeTable} from '../../../components';

const TeacherProfileModal = ({data, onClose}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const isLandscape = useIsLandscape();
  const {name, image, description, subjectId, gradeId} = data ?? {};

  const [
    {loading, value: timeTableData},
    handleGetTeacherSchedules,
  ] = useAsyncFn(
    () =>
      getTeacherSchedules({
        gradeIds: gradeId ? [gradeId] : undefined,
        subjectIds: subjectId ? [subjectId] : undefined,
      }),
    [gradeId, subjectId],
  );

  useEffect(() => {
    if (data) {
      handleGetTeacherSchedules();
    }
  }, [data, handleGetTeacherSchedules]);

  return (
    <Page
      header={{
        title: "Teacher's Profile",
        showBackAction: true,
        onModalBackPressed: onClose,
      }}
      useSidebarView={isLandscape}
      useModalView={!isLandscape}>
      <Layout style={styles.personDetail}>
        <Image
          source={{uri: getImage(image)}}
          resizeMode="contain"
          style={styles.personIcon}
        />
        <Text style={styles.personName}>{name}</Text>
      </Layout>
      <TabView
        tabBarStyle={styles.tabBarStyle}
        selectedIndex={selectedIndex}
        onSelect={(index) => setSelectedIndex(index)}>
        <Tab title="About">
          <Layout>
            <Text style={styles.about}>{safeText(description)}</Text>
          </Layout>
        </Tab>
        <Tab title="Timetable">
          <Layout style={styles.timeTableContainer}>
            {loading ? (
              <AppLoadingIndicator />
            ) : (
              <TimeTable
                data={timeTableData}
                hideTitle
                containerStyle={styles.timeTable}
              />
            )}
          </Layout>
        </Tab>
      </TabView>
    </Page>
  );
};

const styles = StyleSheet.create({
  personDetail: {
    height: px(200),
    justifyContent: 'center',
    alignItems: 'center',
  },
  personIcon: {
    width: px(100),
    height: px(100),
    borderRadius: 50,
    backgroundColor: '#FFEDEF',
  },
  personName: {
    marginTop: px(16),
    fontSize: 18,
    fontWeight: '700',
  },
  tabBarStyle: {
    height: px(48),
  },
  about: {
    paddingVertical: px(24),
    paddingHorizontal: 16,
    fontSize: 16,
  },
  timeTableContainer: {
    paddingTop: px(16),
  },
  timeTable: {
    paddingHorizontal: 0,
  },
});

export default TeacherProfileModal;
